export function getDataInicialSugestaoByDiaVencimento(diaVencimento, baseDate = new Date()) {
  const dia = Number(diaVencimento)
  if (!Number.isInteger(dia) || dia < 1) {
    return null
  }

  const ano = baseDate.getMonth() === 11 ? baseDate.getFullYear() + 1 : baseDate.getFullYear()
  const mes = baseDate.getMonth() === 11 ? 0 : baseDate.getMonth() + 1
  const ultimoDiaProximoMes = new Date(baseDate.getFullYear(), baseDate.getMonth() + 2, 0).getDate()
  const diaAjustado = Math.min(dia, ultimoDiaProximoMes)

  return new Date(ano, mes, diaAjustado, 0, 0, 0, 0).getTime()
}
